import React, {Component} from 'react'
import { GlgRadio } from 'SharedComponents'
import PropTypes from 'prop-types'
import { Col } from 'react-flexbox-grid'

export class BooleanComponent extends Component {
  constructor(props){
    super(props)
  }
  
  render(){
    return <Col xs={12} md={8}><div className="checkbox_radio_container"><GlgRadio name={`answer[${this.props.field.id}]`} label="Yes" value="Yes" defaultChecked={this.props.answer === 'Yes'} disabled={this.props.field.disabled} radioClass={'i-checks'} onChange={(val) => this.props.onChange(this.props.field.id, this.props.field.category, this.props.field.name, val)}></GlgRadio></div><div className="checkbox_radio_container"><GlgRadio name={`answer[${this.props.field.id}]`} label="No" value="No" defaultChecked={this.props.answer === 'No'} disabled={this.props.field.disabled} radioClass={'i-checks'} onChange={(val) => this.props.onChange(this.props.field.id, this.props.field.category, this.props.field.name, val)}></GlgRadio></div></Col>
  }
}

BooleanComponent.propTypes = {
  field: PropTypes.object.isRequired,
  answer: PropTypes.string,
  onChange: PropTypes.func.isRequired,
}

export default BooleanComponent
